<div class="row mb-3">
    <div class="col-xs-12 col-md-12 col-lg-12">
        <div class="card card-nb card-nm rounded-4">
            <div class="d-flex flex-column card-body rounded-4 p-4">
                <div class="d-flex flex-row justify-content-between mb-2 flex-wrap">
                    <h4 class="p-0">{{ 'integration_apps_details_card_header' | i18next }}</h4>
                    @if (isAdmin) {
                        <div class="d-flex">
                            @if (isOwnApp) {
                                <div class="d-flex flex-row align-items-center cursor-pointer mr-3"
                                    [routerLink]="['/integration-apps/newversion', integrationApp.uuid]">
                                    <i class="fa fa-edit red fa-lg mr-1"></i>
                                    <span class="subinformations red">{{ 'integration-apps-detail-card_new_app_version_text' | i18next }}</span>
                                </div>
                            }
                            <div class="d-flex flex-row align-items-center cursor-pointer"
                                (click)="startInstallation(integrationApp.uuid)">
                                <i class="fa fa-download red fa-lg mr-1"></i>
                                @if (preselectedSubId) {
                                    <span class="subinformations red">{{'integration_apps_preselected_subscription_info_btn' |
                                        i18next: { preselectedSubId: preselectedSubId, preselectedSubName: preselectedSubName }
                                    }}</span>
                                } @else {
                                    <span class="subinformations red">{{'integration_apps_install_hint' | i18next}}</span>
                                }
                            </div>
                        </div>
                    }
                </div>
                <div class="d-flex flex-row flex-wrap">
                    <img class="mr-3" src="{{integrationApp.iconUrl}}" alt="Integration App Icon"
                      style=" max-width: 128px; max-height: 128px; border-radius: 10px;">
                    <div class="d-flex flex-column">
                        <span class="font-weight-bold">{{integrationApp.name}}</span>
                        <span class="subinformations"
                            [innerHTML]="'integration-apps-detail-card_display_vendor' | i18next: { vendor: integrationApp.vendor }"></span>
                        @if (isOwnApp) {
                            <span class="subinformations">{{ 'integration-apps-detail-card_latest_app_version' | i18next: { appVersion: integrationAppVersion } }}</span>
                        }
                    </div>
                </div>
                <hr>
                <div class="p-0">
                    <div class="row g-1">
                        <div class="col-12 col-sm-5 mb-2">
                            <div class="d-flex flex-column flex-md-row gap-1">
                                <div class="text-nowrap label-col">{{'name_label' | i18next}}</div>
                                <div class="subinformations value-col">{{integrationApp.name}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-7 mb-2">
                            <div class="d-flex flex-column flex-md-row gap-1">
                                <div class="text-nowrap label-col-longer">{{'documentation_label' | i18next}}</div>
                                <div class="flex-fill text-break value-col"><a href="{{integrationApp.documentationUrl}}"
                                        target="_blank">{{integrationApp.documentationUrl}}</a></div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-5 mb-2">
                            <div class="d-flex flex-column flex-md-row gap-1">
                                <div class="text-nowrap label-col">{{'vendor_label' | i18next}}</div>
                                <div class="subinformations value-col">{{integrationApp.vendor}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-7 mb-2">
                            <div class="d-flex flex-column flex-md-row gap-1">
                                <div class="text-nowrap label-col-longer">{{'website_label' | i18next}}</div>
                                <div class="flex-fill text-break value-col"><a href="{{integrationApp.websiteUrl}}"
                                        target="_blank">{{integrationApp.websiteUrl}}</a></div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-5 mb-2">
                            <div class="d-flex flex-column flex-md-row gap-1">
                                <div class="text-nowrap label-col">{{'support_email_label' | i18next}}</div>
                                <div class="subinformations value-col">{{integrationApp.supportEmail}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-7 mb-2">
                            <div class="d-flex flex-column flex-md-row gap-1">
                                <div class="text-nowrap label-col-longer">{{'privacy_policy_label' | i18next}}</div>
                                <div class="flex-fill text-break value-col"><a href="{{integrationApp.privacyPolicyUrl}}"
                                        target="_blank">{{integrationApp.privacyPolicyUrl}}</a></div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="d-flex flex-column flex-md-row gap-1">
                                <div class="text-nowrap label-col">{{'description_label' | i18next}}</div>
                                <p class="flex-fill text-break subinformations value-col">{{integrationApp.description}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>